(function () {
  'use strict';

  var pageLanguage = document.documentElement.lang || '';

  if (!/^fr(?:-|$)/i.test(pageLanguage)) return;

  var ignoredElements = [
    'script',
    'style',
    'noscript',
    'template',
    'textarea',
    'pre',
    'code',
    'kbd',
    'samp',
    'svg',
    'math',
    '[contenteditable="true"]',
    '[data-french-typography-ignore]',
  ].join(',');

  function formatFrenchTypography(text) {
    return text
      .replace(/[ \t\u00a0\u202f]+:/g, '\u00a0:')
      .replace(/[ \t\u00a0\u202f]+([;!?»])/g, '\u202f$1')
      .replace(/«[ \t\u00a0\u202f]+/g, '«\u202f')
      .replace(/(\d)[ \t\u00a0\u202f]+h[ \t\u00a0\u202f]+(?=\d)/gi, '$1\u00a0h\u00a0')
      .replace(/(\d)[ \t\u00a0\u202f]+h\b/gi, '$1\u00a0h')
      .replace(/\b(n[°º])[ \t\u00a0\u202f]+(?=\d)/gi, '$1\u00a0')
      .replace(/(\d)[ \t\u00a0\u202f]+(?=(?:%|€)(?:[\s.,;:!?)]|$))/g, '$1\u00a0')
      .replace(
        /(\d)[ \t\u00a0\u202f]+(?=(?:EUR|CHF|USD|kg|mg|g|km|cm|mm|m|cl|ml|l|min|°C|°F)\b)/gi,
        '$1\u00a0'
      )
      .replace(/([€$£])[ \t\u00a0\u202f]+(?=\d)/g, '$1\u00a0');
  }

  function canFormat(textNode) {
    var parent = textNode.parentElement;

    return parent && !parent.closest(ignoredElements);
  }

  function formatTextNode(textNode) {
    if (!canFormat(textNode)) return;

    var formattedText = formatFrenchTypography(textNode.nodeValue);

    if (formattedText !== textNode.nodeValue) {
      textNode.nodeValue = formattedText;
    }
  }

  function formatTree(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      formatTextNode(root);
      return;
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var textNode;

    while ((textNode = walker.nextNode())) {
      formatTextNode(textNode);
    }
  }

  function initializeFrenchTypography() {
    formatTree(document.body);

    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, formatTree);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFrenchTypography, { once: true });
  } else {
    initializeFrenchTypography();
  }
})();
